export default "__VITE_ASSET__DYGpfZLq__"